import { render, staticRenderFns } from "./RemoveMaterialModal.vue?vue&type=template&id=47b5d5a6&"
import script from "./RemoveMaterialModal.vue?vue&type=script&lang=js&"
export * from "./RemoveMaterialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports